import React from "react";
import cn from "classnames";
import styles from "./style.scss";
import Cancel from "images/icon/cancel.svg";

interface Props {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  error?: string;
  inputRef?: React.Ref<HTMLInputElement>;
}

// テキストフィールドコンポーネント
// https://www.figma.com/design/vscnaU8iyULILBftJwUeUb/01-01.NKVS_modules?node-id=2704-147&m=dev
const TextField: React.FC<Props> = ({
  value,
  onChange,
  disabled = false,
  error,
  inputRef
}) => {
  return (
    <>
      <label
        className={cn(styles.wrapper, {
          [styles.errorWrapper]: error,
          [styles.disabledWrapper]: disabled
        })}
      >
        <input
          ref={inputRef}
          type="text"
          value={value}
          onChange={e => onChange(e.target.value)}
          disabled={disabled}
        />
        {!disabled && (
          <button className={styles.clearButton} onClick={() => onChange("")}>
            <img src={Cancel} alt="Cancel" />
          </button>
        )}
      </label>
      {error && <p className={styles.error}>{error}</p>}
    </>
  );
};

export default TextField;
